import { useState } from 'react';
import { useRouter } from 'next/router';
import ImageWithFallback from '@/components/shared/ImageWithFallback';
import { Button } from '@/components/ui/button';
import CustomDialog from '@/components/ui/customDialog';
import ReferralModal from './ReferralModal';
import { useIsMobile } from '@/hooks/utilities/use-mobile';
export default function ReferralBanner({
  small = false
}: {
  small?: boolean;
}) {
  const router = useRouter();
  const isMobile = useIsMobile();
  const [showModal, setShowModal] = useState(false);
  function toggleModal() {
    if (isMobile) {
      router.push('/refer');
      return;
    } else {
      setShowModal(!showModal);
    }
  }
  return <div className={`flex flex-col justify-center items-center ${!small ? 'gap-4' : 'gap-3'} genius-shadow bg-genius-indigo rounded-[20px] overflow-hidden max-h-[100%] h-full w-full referalBanner p-4 border border-genius-blue`} data-sentry-component="ReferralBanner" data-sentry-source-file="ReferralBanner.tsx">
      <ImageWithFallback src='/Union.png' alt='logo' width={20} height={20} data-sentry-element="ImageWithFallback" data-sentry-source-file="ReferralBanner.tsx" />

      {!small ? <div className='tracking-[-2px] text-[32px] text-genius-gradient-normal font-normal leading-[90%]'>
          Refer your friends
        </div> : null}

      <div className='text-[14px] text-genius-gradient-dark tracking-[-1px] px-2 leading-5 ta-c whitespace-nowrap'>
        Refer your friends to earn rewards on Genius.
      </div>
      <Button onClick={toggleModal} className={`tracking-[-1px] rounded-full flex items-center justify-center ta-c bg-genius-pink hover:opacity-80 text-genius-blue transition-opacity ${!small ? 'w-full max-w-[270px] h-[56px]' : ''}`} data-sentry-element="Button" data-sentry-source-file="ReferralBanner.tsx">
        Refer A Friend
      </Button>
      <CustomDialog isOpen={showModal} toggleModal={toggleModal} hideClose={true} className={'p-0'} data-sentry-element="CustomDialog" data-sentry-source-file="ReferralBanner.tsx">
        <ReferralModal toggleModal={toggleModal} data-sentry-element="ReferralModal" data-sentry-source-file="ReferralBanner.tsx" />
      </CustomDialog>
    </div>;
}